/**
 * @description This is a list of words that should not be capitalized for title case.
 * @private
 */
export const non_titlecased_words = [
	'and', 'or', 'nor', 'a', 'an', 'the', 'so', 'but', 'to', 'of', 'at', 'by',
	'from', 'into', 'on', 'onto', 'off', 'out', 'in', 'over', 'with', 'for',
];

export default non_titlecased_words
